// Exports: BulkActionBar
import React from "react";
import { Trash2 } from "lucide-react";

const BulkActionBar = ({
  siteMembers,
  bulkMembers,
  bulkPriority,
  setBulkPriority,
  toggleBulkMemberSelection,
  showBulkAssigneeDropdown,
  setShowBulkAssigneeDropdown,
  bulkSaving,
  bulkDeleting,
  onSave,
  onDelete,
  onReset,
  getInitials,
}) => (
  <div
    className="ml-1 flex items-center gap-2"
    onClick={(event) => event.stopPropagation()}
  >
    <div className="relative flex items-center gap-2">
      <div
        onClick={(event) => {
          event.stopPropagation();
          setShowBulkAssigneeDropdown((current) => !current);
        }}
        className="py-1 px-2 bg-white rounded-lg border text-sm text-gray-600"
      >
        Assignees {bulkMembers.length ? `(${bulkMembers.length})` : ""}
      </div>
      {showBulkAssigneeDropdown && (
        <div
          className="absolute top-full left-0 mt-1 z-30 bg-white rounded-lg shadow-lg border p-2 w-72 max-h-60 overflow-y-auto"
          onClick={(event) => event.stopPropagation()}
        >
          {siteMembers.map((member) => (
            <div
              key={member.member_id}
              className={`flex items-center justify-between px-2 py-1 rounded cursor-pointer hover:bg-gray-100 ${
                bulkMembers.includes(member.member_id) ? "bg-gray-50" : ""
              }`}
              onClick={() =>
                toggleBulkMemberSelection(Number(member.member_id))
              }
            >
              <div className="flex items-center">
                {member?.userpic ? (
                  <img
                    src={member.userpic}
                    alt={`${member.first_name} ${member.last_name}`}
                    className="w-6 h-6 rounded-full border-2 border-white mr-2"
                  />
                ) : (
                  <span
                    className="w-6 h-6 rounded-full bg-[#343C6A] text-white text-xs flex items-center justify-center mr-2"
                    title={`${member.first_name} ${member.last_name}`}
                  >
                    {getInitials(`${member.first_name} ${member.last_name}`)}
                  </span>
                )}
                <span className="text-sm text-gray-700">
                  {member.first_name} {member.last_name}
                </span>
              </div>
              <input
                type="checkbox"
                className="h-4 w-4 text-purple-600 focus:ring-purple-500 border-gray-300 rounded"
                checked={bulkMembers.includes(member.member_id)}
                onChange={() =>
                  toggleBulkMemberSelection(Number(member.member_id))
                }
              />
            </div>
          ))}
        </div>
      )}
    </div>

    <div className="flex items-center gap-2">
      <select
        value={bulkPriority}
        onChange={(event) => setBulkPriority(event.target.value)}
        className="border rounded px-2 py-1 text-sm bg-white"
      >
        <option value="">Select Priority</option>
        <option value="High">High</option>
        <option value="Medium">Medium</option>
        <option value="Low">Low</option>
      </select>
    </div>

    <div className="flex items-center gap-2 ml-2">
      <button
        disabled={bulkSaving || bulkDeleting}
        onClick={onSave}
        className={`px-3 py-1 rounded text-white ${
          bulkSaving || bulkDeleting
            ? "bg-gray-400"
            : "bg-btn-bg hover:bg-purple-800"
        } text-sm`}
      >
        {bulkSaving ? "Saving…" : "Save"}
      </button>
      <button
        disabled={bulkSaving || bulkDeleting}
        onClick={onDelete}
        className={`px-3 py-1 rounded border text-sm flex items-center gap-1 ${
          bulkSaving || bulkDeleting
            ? "text-gray-400 bg-gray-50"
            : "text-red-600 border-red-200 hover:bg-red-50"
        }`}
      >
        <Trash2 className="w-4 h-4" />
        {bulkDeleting ? "Deleting…" : "Delete"}
      </button>
      <button
        disabled={bulkSaving || bulkDeleting}
        onClick={onReset}
        className="px-3 py-1 rounded border text-sm"
      >
        Reset
      </button>
    </div>
  </div>
);

export default BulkActionBar;
